import { motion } from "framer-motion";
import { scrollToSection } from "../../lib/scroll";

const fadeUp = {
  initial: { opacity: 0, y: 24 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-60px" },
  transition: { duration: 0.7 },
};

export default function AboutSection() {
  return (
    <section id="about" data-testid="about-section" className="py-24 md:py-32 border-b border-line bg-surface1">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <motion.p {...fadeUp} className="font-mono text-xs uppercase tracking-[0.3em] text-ochre mb-6">About</motion.p>
        <motion.h2 {...fadeUp} data-testid="about-heading" className="font-serif text-3xl md:text-5xl tracking-tight mb-12 max-w-4xl">
          About <em className="text-ember">Bigibila.</em>
        </motion.h2>
        <div className="grid lg:grid-cols-12 gap-14">
          <motion.div {...fadeUp} className="lg:col-span-7">
            <div className="space-y-6 text-stone2 leading-relaxed max-w-2xl">
              <p data-testid="about-body-1">
                Bigibila is a First Nations-led enterprise founded by Liana Pitt,
                a Yuwaalaraay–Gamilaraay woman and governance systems designer.
              </p>
              <p data-testid="about-body-2">
                Bigibila works across institutional governance, First Nations
                data sovereignty, cultural accountability and systems reform.
                Its work brings together cultural authority, lived systems
                knowledge, rigorous analysis and practical implementation.
              </p>
              <p data-testid="about-body-3">
                Bigibila Governance Archaeology and associated architectures are
                sovereign Yuwaalaraay–Gamilaraay intellectual assets held within
                the Bigibila enterprise.
              </p>
              <p className="font-serif italic text-xl md:text-2xl text-bone/90 border-l-2 border-ember pl-6 py-1" data-testid="about-quote">
                "The governance remains yours. Bigibila provides the methodology."
              </p>
              <p className="text-sm text-stone2" data-testid="about-credibility">
                The methodology is undergoing structured methodological review
                and reliability testing; approved evidence summaries are
                published as the research record is finalised.
              </p>
            </div>
            <div className="flex flex-wrap gap-4 mt-10">
              <a href="mailto:liana@bigibila.com.au" data-testid="about-email-link" className="link-underline font-mono text-sm text-bone hover:text-ember transition-colors duration-300 w-fit">
                liana@bigibila.com.au
              </a>
              <button type="button" onClick={() => scrollToSection("rigour")} data-testid="about-rigour-link" className="font-mono text-xs uppercase tracking-[0.2em] px-6 py-3.5 border border-line text-bone hover:border-ember hover:text-ember transition-colors duration-300">
                Research rigour
              </button>
            </div>
          </motion.div>

          <motion.div {...fadeUp} transition={{ duration: 0.9, delay: 0.1 }} className="lg:col-span-5">
            <div className="relative">
              <div className="absolute -inset-3 border border-line" />
              <img
                src="/liana-barbara.jpg"
                alt="Liana Pitt and Barbara Fernando"
                data-testid="about-photo"
                className="relative w-full h-[460px] object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-ink/75 to-transparent" />
              <p className="absolute bottom-3 left-4 right-4 font-mono text-[10px] uppercase tracking-[0.2em] text-bone/90 leading-relaxed">
                Liana Pitt &amp; Barbara Fernando<br />
                <span className="text-ochre">Walgett Gingi · Kamilaroi Yinnara</span>
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
